import { render, staticRenderFns } from "./UnitOfMeasureDialog.vue?vue&type=template&id=15f06f3c"
import script from "./UnitOfMeasureDialog.vue?vue&type=script&lang=ts"
export * from "./UnitOfMeasureDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports